import {Component, Input, OnInit} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'xplorer-bowser-instagram-info-item',
    templateUrl: './instagram-info-item.component.html',
    styleUrls: ['./instagram-info-item.component.css'],
    imports: [TranslateModule]
})
export class InstagramInfoItemComponent implements OnInit {

  @Input()
  instagramLink: string;

  constructor() { }

  ngOnInit(): void {
  }

  openInstagram(): void {
    open(this.instagramLink, '_blank').focus();
  }

}
